var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 4.5,
    stroke: "#ADB5BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5v2h2",
    stroke: "#ADB5BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgTime16;